var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
var IconCellPhone = function (props) {
    return (_jsx("svg", __assign({ width: '21', height: '20', viewBox: '0 0 21 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, props, { children: _jsx("path", { d: 'M13.7252 1.66663H6.71286C6.04175 1.66663 5.5 2.2108 5.5 2.8807V17.1204C5.5 17.7897 6.04175 18.3333 6.71286 18.3333H13.7252C14.3951 18.3333 14.9381 17.7897 14.9381 17.1204V2.8807C14.9381 2.2108 14.3951 1.66663 13.7252 1.66663ZM8.48873 2.40394H11.9506C12.038 2.40394 12.1091 2.53452 12.1091 2.69607C12.1091 2.85762 12.038 2.98881 11.9506 2.98881H8.48873C8.40066 2.98881 8.33082 2.85762 8.33082 2.69607C8.33082 2.53452 8.40066 2.40394 8.48873 2.40394ZM10.2197 17.135C9.79269 17.135 9.44529 16.7876 9.44529 16.36C9.44529 15.9325 9.79269 15.5863 10.2197 15.5863C10.6454 15.5863 10.9928 15.9325 10.9928 16.36C10.9928 16.7876 10.6454 17.135 10.2197 17.135ZM14.0295 14.4815H6.40919V3.71519H14.0295V14.4815Z', fill: '#68239A' }) })));
};
export default IconCellPhone;
